<headerCustom></headerCustom>

<sidebarWrapper></sidebarWrapper>

<div class="main-content" style="font-family: 'Roboto'">
	<div class="adduserContainer">
		<div class="pageContentWrapper">
			<div class="pageHeading">
				<div class="row">
					<div class="col-12">
						<div class="headerName">
							<h3>Competency Report</h3>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12">
					<div class="scoreCompStyle" id="adduserPopContainer">
						<div>
							<div class="headerName">
								<div class="row">
									<div class="col-sm-3  inputDivContainer" *ngIf="userRole != 7">
										<label class="">Select IBU</label>
										<select class="form-control" [(ngModel)]="selectedIbuId"
											(ngModelChange)="changeIbu()">
											<option value=""> Select IBU</option>
											<ng-container *ngFor="let ibulist of ibuList; let i = index;">
												<option value="{{ibulist?.ibuId}}">
													{{ibulist?.ibuName}}
												</option>
											</ng-container>
										</select>
									</div>
									<div class="col-sm-3  inputDivContainer" *ngIf="userRole == 7">
										<label class="">Select IBU</label>
										<select class="form-control" [(ngModel)]="selectedIbuId"
											(ngModelChange)="changeIbu()">
											<option value=""> Select IBU</option>
											<ng-container *ngFor="let ibulist of ibuListForTraining; let i = index;">
												<option value="{{ibulist?.ibuId}}">
													{{ibulist?.ibuName}}
												</option>
											</ng-container>
										</select>
									</div>
									<div class="col-sm-3  inputDivContainer">
										<label class="">Select Tower</label>
										<select class="form-control" [(ngModel)]="selectedTowerId"
											(ngModelChange)="changeTower()" [disabled]="(!selectedIbuId) ? true : false ">
											<option value=""> Select Tower</option>
											<ng-container *ngFor="let towerList of towerList; let i = index;">
												<option value="{{towerList?.towerId}}">
													{{towerList?.towerName}}
												</option>
											</ng-container>
										</select>
									</div>
									<div class="col-md-3 addUserButton txt-right">
										<label class="col-md-12" style="margin-top: 19px"> </label>
										<button type="button" class="btn hvr-bounce-to-top" (click)="getUserReportData()"
										[disabled]="(!selectedIbuId) ? true : false ">
											Export Report</button>
									
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<br>
			
			
		</div>
	</div>
</div>

<div class="loader" *ngIf="loading">
    <div class="lds-roller">
        <!-- <img src="assets/preloader.gif" />
        <span>Wait...</span> -->
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>